document.documentElement.classList.add('rx-js');

function initRichoraxHeader(root = document) {
  root.querySelectorAll('[data-rx-header]').forEach((header) => {
    if (header.dataset.rxReady === 'true') return;
    const toggle = header.querySelector('[data-rx-menu-toggle]');
    const menu = header.querySelector('[data-rx-menu]');
    if (!toggle || !menu) return;

    const closeMenu = ({ returnFocus = false } = {}) => {
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      if (returnFocus) toggle.focus();
    };

    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(willOpen));
      menu.hidden = !willOpen;
      if (willOpen) menu.querySelector('a')?.focus();
    });

    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu({ returnFocus: true });
      }
    });

    const syncViewport = () => {
      if (window.matchMedia('(min-width: 750px)').matches) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = false;
      } else if (toggle.getAttribute('aria-expanded') !== 'true') {
        menu.hidden = true;
      }
    };

    window.addEventListener('resize', syncViewport);
    syncViewport();

    header.dataset.rxReady = 'true';
  });
}

document.addEventListener('DOMContentLoaded', () => initRichoraxHeader());
document.addEventListener('shopify:section:load', (event) => initRichoraxHeader(event.target));

function initRichoraxLocalization(root = document) {
  root.querySelectorAll('form.rx-localization').forEach((form) => {
    if (form.dataset.rxReady === 'true') return;
    const toggle = form.querySelector('[data-rx-localization-toggle]');
    const panel = form.querySelector('[data-rx-localization-panel]');
    const input = form.querySelector('[data-rx-country-input]');
    const languageInput = form.querySelector('[data-rx-language-input]');
    const closeButton = form.querySelector('[data-rx-localization-close]');
    const options = Array.from(form.querySelectorAll('[data-rx-country-code]'));
    if (!toggle || !panel || !input || !options.length) return;

    const close = ({ returnFocus = false } = {}) => {
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (returnFocus) toggle.focus();
    };

    const open = () => {
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      (options.find((option) => option.getAttribute('aria-selected') === 'true') || options[0]).focus();
    };

    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('aria-expanded') === 'true') close(); else open();
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const countryCode = option.dataset.rxCountryCode;
        if (!countryCode) return;
        input.value = countryCode;
        if (languageInput && option.dataset.rxLanguageCode) languageInput.value = option.dataset.rxLanguageCode;
        close();
        form.submit();
      });
      option.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = options.indexOf(option);
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : event.key === 'ArrowDown' ? (currentIndex + 1) % options.length : (currentIndex - 1 + options.length) % options.length;
        options[nextIndex].focus();
      });
    });
    closeButton?.addEventListener('click', () => close({ returnFocus: true }));

    form.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        close({ returnFocus: true });
      }
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
    form.dataset.rxReady = 'true';
  });
}

document.addEventListener('DOMContentLoaded', () => initRichoraxLocalization());
document.addEventListener('shopify:section:load', (event) => initRichoraxLocalization(event.target));

function initRichoraxAccount(root = document) {
  root.querySelectorAll('[data-rx-account]').forEach((account) => {
    if (account.dataset.rxReady === 'true') return;
    const toggle = account.querySelector('[data-rx-account-toggle]');
    const panel = account.querySelector('[data-rx-account-panel]');
    const closeButton = account.querySelector('[data-rx-account-close]');
    const status = account.querySelector('[data-rx-account-status]');
    if (!toggle || !panel) return;
    const close = ({ returnFocus = false } = {}) => {
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (returnFocus) toggle.focus();
    };
    const open = () => {
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.querySelector('a,button')?.focus();
    };
    toggle.addEventListener('click', () => toggle.getAttribute('aria-expanded') === 'true' ? close() : open());
    closeButton?.addEventListener('click', () => close({ returnFocus: true }));
    account.querySelectorAll('[data-rx-account-message]').forEach((button) => button.addEventListener('click', () => {
      if (!status) return;
      status.textContent = button.dataset.rxAccountMessage || '';
      status.hidden = false;
    }));
    account.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close({ returnFocus: true }); }
    });
    document.addEventListener('click', (event) => { if (!account.contains(event.target)) close(); });
    account.dataset.rxReady = 'true';
  });
}

function initRichoraxContact(root = document) {
  root.querySelectorAll('[data-rx-contact-dialog]').forEach((dialog) => {
    if (dialog.dataset.rxReady === 'true') return;
    const section = dialog.closest('.shopify-section') || document;
    const openButton = section.querySelector('[data-rx-contact-open]');
    const closeButton = dialog.querySelector('[data-rx-contact-close]');
    const type = dialog.querySelector('[data-rx-contact-type]');
    const email = dialog.querySelector('[data-rx-contact-email]');
    const open = () => {
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.body.classList.add('rx-contact-open');
    };
    const close = () => {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
      document.body.classList.remove('rx-contact-open');
      openButton?.focus();
    };
    openButton?.addEventListener('click', open);
    closeButton?.addEventListener('click', close);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    dialog.querySelectorAll('[data-rx-contact-mode]').forEach((button) => button.addEventListener('click', () => {
      if (type) type.value = button.dataset.rxContactMode || 'General enquiry';
      email?.focus();
    }));
    if (dialog.querySelector('[data-rx-contact-auto-open],.errors')) open();
    dialog.dataset.rxReady = 'true';
  });
}

document.addEventListener('DOMContentLoaded', () => { initRichoraxAccount(); initRichoraxContact(); });
document.addEventListener('shopify:section:load', (event) => { initRichoraxAccount(event.target); initRichoraxContact(event.target); });

function initRichoraxSearch(root = document) {
  root.querySelectorAll('[data-rx-header]').forEach((header) => {
    const form = header.querySelector('[data-rx-search-form]');
    const input = header.querySelector('[data-rx-search-input]');
    const results = header.querySelector('[data-rx-predictive-search]');
    const toggle = header.querySelector('[data-rx-search-toggle]');
    if (!form || !input || !results || form.dataset.rxReady === 'true') return;

    let controller;
    let timer;
    const close = () => {
      results.hidden = true;
      results.replaceChildren();
      form.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
    };
    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    const renderGroup = (title, items) => {
      if (!items?.length) return '';
      return `<section><p class="rx-predictive-search__heading">${escapeHtml(title)}</p>${items.map((item) => `<a href="${escapeHtml(item.url)}"><span>${escapeHtml(item.title)}</span>${item.price ? `<small>${escapeHtml(item.price)}</small>` : ''}</a>`).join('')}</section>`;
    };

    const runSearch = async () => {
      const query = input.value.trim();
      if (query.length < 2) { close(); return; }
      controller?.abort();
      controller = new AbortController();
      const rootUrl = window.Shopify?.routes?.root || '/';
      const endpoint = `${rootUrl}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`;
      results.hidden = false;
      results.innerHTML = '<p class="rx-predictive-search__status">Searching…</p>';
      try {
        const response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const groups = (await response.json()).resources?.results || {};
        const html = [renderGroup('Products', groups.products), renderGroup('Collections', groups.collections), renderGroup('Resources', [...(groups.pages || []), ...(groups.articles || [])])].join('');
        results.innerHTML = html || '<p class="rx-predictive-search__status">No suggestions. Press Enter for full search.</p>';
      } catch (error) {
        if (error.name !== 'AbortError') results.innerHTML = '<p class="rx-predictive-search__status">Press Enter for full search.</p>';
      }
    };

    input.addEventListener('input', () => { window.clearTimeout(timer); timer = window.setTimeout(runSearch, 180); });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) runSearch(); });
    toggle?.addEventListener('click', () => {
      const willOpen = !form.classList.contains('is-open');
      form.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) input.focus(); else close();
    });
    header.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); toggle?.focus(); } });
    document.addEventListener('click', (event) => { if (!form.contains(event.target) && !toggle?.contains(event.target)) close(); });
    form.dataset.rxReady = 'true';
  });
}

document.addEventListener('DOMContentLoaded', () => initRichoraxSearch());
document.addEventListener('shopify:section:load', (event) => initRichoraxSearch(event.target));

async function refreshRichoraxCartCount() {
  const links = document.querySelectorAll('[data-rx-cart-link]');
  if (!links.length) return;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    links.forEach((link) => {
      const count = link.querySelector('[data-rx-cart-count]');
      if (count) {
        count.textContent = String(cart.item_count);
        count.classList.toggle('is-empty', cart.item_count === 0);
      }
      link.setAttribute('aria-label', cart.item_count > 0 ? `Cart, ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}` : 'Cart');
    });
  } catch (error) {
    // Keep the server-rendered count when the cart endpoint is unavailable.
  }
}

document.addEventListener('cart:refresh', refreshRichoraxCartCount);
document.addEventListener('cart:updated', refreshRichoraxCartCount);
document.addEventListener('submit', (event) => {
  if (event.target.matches('form[action*="/cart/add"]')) window.setTimeout(refreshRichoraxCartCount, 500);
});

function initRichoraxJournalPopup(root = document) {
  const popup = root.querySelector('[data-rx-journal-popup]');
  if (!popup || popup.dataset.rxReady === 'true') return;

  const storageKey = 'richoraxJournalPopupDismissed';
  const closeButtons = popup.querySelectorAll('[data-rx-journal-close]');
  const panel = popup.querySelector('.rx-journal-popup__panel');
  const email = popup.querySelector('input[type="email"]');
  let returnFocus = null;

  const focusable = () => Array.from(popup.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]'));
  const closePopup = () => {
    popup.hidden = true;
    document.body.classList.remove('rx-popup-open');
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) { /* Storage can be unavailable. */ }
    returnFocus?.focus?.();
  };

  const openPopup = () => {
    returnFocus = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('rx-popup-open');
    window.requestAnimationFrame(() => email?.focus());
  };

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  popup.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup();
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  let dismissedAt = 0;
  try { dismissedAt = Number(localStorage.getItem(storageKey) || 0); } catch (error) { /* Storage can be unavailable. */ }
  const thirtyDays = 30 * 24 * 60 * 60 * 1000;
  if (!dismissedAt || Date.now() - dismissedAt > thirtyDays) {
    const delay = window.matchMedia('(max-width: 749px)').matches ? Number(popup.dataset.mobileDelay) : Number(popup.dataset.desktopDelay);
    window.setTimeout(openPopup, Number.isFinite(delay) ? delay : 8000);
  }

  popup.dataset.rxReady = 'true';
}

document.addEventListener('DOMContentLoaded', () => initRichoraxJournalPopup());
document.addEventListener('shopify:section:load', (event) => initRichoraxJournalPopup(event.target));
